import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function Agents() {
  const [agents, setAgents] = useState([]);
  useEffect(() => {
    api.get("/agents").then((r) => {
      // Backend already excludes admins from /api/agents, but we double-guard
      // client-side so a stale response can never leak an admin card onto the
      // public team page.
      const visible = (r.data.items || []).filter((a) => a.role !== "admin");
      setAgents(visible);
    });
  }, []);
  return (
    <div data-testid="agents-page">
      <SEO title="Meet our advisors" description="Point Penta's Dubai advisors — private-banker discipline, real-estate expertise." path="/agents" />
      <section className="pt-6 pb-14 border-b border-neutral-200">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Team", path: "/agents" }]} />
          <div className="overline text-[#001588] mb-4">Team</div>
          <h1 className="font-serif text-5xl lg:text-7xl leading-tight max-w-4xl">Advisors,<br/><span className="italic text-neutral-600">not salespeople.</span></h1>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
          {agents.map((a) => (
            <Link
              key={a.id} to={`/agents/${a.id}`}
              data-testid={`agent-card-${a.id}`}
              className="group block"
            >
              <div className="pp-hover-zoom aspect-[3/4] mb-5 bg-[#ffffff]">
                {a.photo_url
                  ? <img src={a.photo_url} alt={a.name} className="w-full h-full object-cover" />
                  : <div className="w-full h-full flex items-center justify-center text-neutral-300 font-serif text-4xl">{a.name.split(" ").map((n) => n[0]).join("").slice(0, 2)}</div>
                }
              </div>
              <div className="overline text-[#001588] mb-2">{a.role === "founding_partner" ? "Founding Partner" : "Advisor"}</div>
              <h2 className="font-serif text-2xl group-hover:text-[#001588] transition-colors">{a.name}</h2>
              {a.specializations?.length > 0 && (
                <p className="text-sm text-neutral-500 mt-2">{a.specializations.slice(0, 3).join(" · ")}</p>
              )}
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
